import React from "react";

const AmountSummary = ({
    subTotal = 0,
    cgst = 0,
    sgst = 0,
    igst = 0,
    roundOff = 0,
    showRoundOff = false,
    adjustment = 0,
    setAdjustment,
    currencySymbol = "₹",
}) => {
    const adjVal = Number.isNaN(Number.parseFloat(adjustment)) ? 0 : Number.parseFloat(adjustment);
    const finalTotal =
        subTotal + cgst + sgst + igst + (showRoundOff ? roundOff : 0) + adjVal;

    const rowStyle = {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: "10px",
        fontSize: "14px",
        color: "#212129",
    };

    return (
        <div style={{ maxWidth: "380px", marginLeft: "auto", marginTop: "15px" }}>
            {/* Sub Total */}
            <div style={{ ...rowStyle, fontWeight: 600 }}>
                <span>Sub Total</span>
                <span>{currencySymbol} {subTotal.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>

            <hr className="my-2" />

            {/* Taxes */}
            {cgst > 0 && (
                <div style={rowStyle}>
                    <span style={{ color: "#6B7280" }}>CGST</span>
                    <span>{currencySymbol} {cgst.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
            )}

            {sgst > 0 && (
                <div style={rowStyle}>
                    <span style={{ color: "#6B7280" }}>SGST</span>
                    <span>{currencySymbol} {sgst.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
            )}

            {igst > 0 && (
                <div style={rowStyle}>
                    <span style={{ color: "#6B7280" }}>IGST</span>
                    <span>{currencySymbol} {igst.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
                </div>
            )}

            {showRoundOff && (
                <div style={rowStyle}>
                    <span style={{ color: "#6B7280" }}>Round-off</span>
                    <span>
                        {roundOff > 0 ? "+" : ""}
                        {currencySymbol} {roundOff.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </span>
                </div>
            )}

            {/* Adjustments Row */}
            <div style={{ ...rowStyle, alignItems: "center" }}>
                <span style={{ color: "#6B7280" }}>Adjustments</span>
                <div style={{ position: "relative", width: "120px" }}>
                    <input
                        type="text"
                        className="adjustment-input"
                        value={adjustment === 0 || adjustment === "" ? "" : (adjustment > 0 && !String(adjustment).startsWith("+") ? `+${adjustment}` : adjustment)}
                        onChange={(e) => {
                            const val = e.target.value.replace(/[^-0-9]/g, "");
                            if (setAdjustment) setAdjustment(val);
                        }}
                        style={{
                            width: "100%",
                            border: "1px solid #E5E7EB",
                            borderRadius: "12px",
                            padding: "6px 15px",
                            textAlign: "right",
                            fontSize: "14px",
                            fontWeight: 600,
                            color: "#212129",
                            outline: "none",
                            background: "#fff"
                        }}
                    />
                </div>
            </div>

            <hr className="my-2" />

            {/* Total */}
            <div style={{ ...rowStyle, fontWeight: 600, fontSize: "16px", marginTop: "10px" }}>
                <span style={{ color: "#001B44" }}>Total Amount</span>
                <span style={{ color: "#001B44", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "200px", textAlign: "right" }}>{currencySymbol} {finalTotal.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</span>
            </div>
        </div>
    );
};

export default AmountSummary;
